import React from "react"
import TitlePic from "./titlepic"
import Picture from "./picture"
import Video from "./video"
import Audio from "./audio"
const Detail=(props)=>{
let type=props.data.type //0图文 1图片   2视频   3音频
let data=props.data
let info=props.info
    switch(type){
        case 0:
            return <TitlePic data={data} info={info}/>;
        case 1:
            return <Picture data={data}/>;
        case 2:
            return <Video data={data}/>;
        case 3:
            return <Audio data={data}/>;
            default:
                return null
    }
}

export default Detail